export class AzurePostgresDatabaseRestoreDestination {
    'azurePostgresDatabase';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "azurePostgresDatabase",
            "baseName": "azurePostgresDatabase",
            "type": "AzurePostgresDatabaseRestoreTarget",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return AzurePostgresDatabaseRestoreDestination.attributeTypeMap;
    }
    constructor() {
    }
}
